// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appCard__S5pa6 {
  width: 100%;
  flex: 1 1 calc(50% - 25px);
  min-width: 500px;
  display: flex;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
}

.appCardIcon__kHRdW {
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid var(--tables-primary-row-stroke);
}
.appCardIcon__kHRdW > img:first-child {
  margin-bottom: 10px;
}

.appCardBody__Hx3fj {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  width: 100%;
}

.appCardBodyTextWrapper__RbeEL {
  padding: 25px;
}
@media (max-width: 800px) {
  .appCardBodyTextWrapper__RbeEL {
    padding: 15px;
  }
}

.appCardLink__YvtJy {
  color: var(--buttons-text-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-decoration-line: none;
  text-transform: uppercase;
}
.appCardLink__YvtJy:hover {
  color: var(--buttons-hover);
}
.appCardLink__YvtJy:active {
  color: var(--buttons-focused);
}

.appCardFooter___A1Nj {
  width: 100%;
  border-top: 1px solid var(--tables-primary-row-stroke);
  display: flex;
  justify-content: flex-end;
  padding: 15px 25px;
}
@media (max-width: 800px) {
  .appCardFooter___A1Nj {
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/HelpAndResources/components/AppCard/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,qDAAA;EACA,sCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,wDAAA;AAzEF;AA2EE;EACE,mBAAA;AAzEJ;;AA6EA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AA1EF;;AA6EA;EACE,aAAA;AA1EF;AA4EE;EAHF;IAII,aAAA;EAzEF;AACF;;AA4EA;EACE,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;AAzEF;AA2EE;EACE,2BAAA;AAzEJ;AA4EE;EACE,6BAAA;AA1EJ;;AA8EA;EACE,WAAA;EACA,sDAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AA3EF;AA6EE;EAPF;IAQI,aAAA;EA1EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.appCard {\n  width: 100%;\n  flex: 1 1 calc(50% - 25px);\n  min-width: 500px;\n  display: flex;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n}\n\n.appCardIcon {\n  padding: 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-right: 1px solid var(--tables-primary-row-stroke);\n\n  & > img:first-child {\n    margin-bottom: 10px;\n  }\n}\n\n.appCardBody {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  width: 100%;\n}\n\n.appCardBodyTextWrapper {\n  padding: 25px;\n\n  @media (max-width: 800px) {\n    padding: 15px;\n  }\n}\n\n.appCardLink {\n  color: var(--buttons-text-secondary);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-decoration-line: none;\n  text-transform: uppercase;\n\n  &:hover {\n    color: var(--buttons-hover);\n  }\n\n  &:active {\n    color: var(--buttons-focused);\n  }\n}\n\n.appCardFooter {\n  width: 100%;\n  border-top: 1px solid var(--tables-primary-row-stroke);\n  display: flex;\n  justify-content: flex-end;\n  padding: 15px 25px;\n\n  @media (max-width: 800px) {\n    padding: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appCard": `appCard__S5pa6`,
	"appCardIcon": `appCardIcon__kHRdW`,
	"appCardBody": `appCardBody__Hx3fj`,
	"appCardBodyTextWrapper": `appCardBodyTextWrapper__RbeEL`,
	"appCardLink": `appCardLink__YvtJy`,
	"appCardFooter": `appCardFooter___A1Nj`
};
module.exports = ___CSS_LOADER_EXPORT___;
